import { createFileRoute } from "@tanstack/react-router";
import NCFreedomDealer from "@/pages/NCFreedomDealer";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/nc-freedom-popup-dealer/")({
  head: () => pageHead({ title: 'NC Freedom Popup Dealer', description: 'Rex & Sons RVs is your North Carolina Freedom popup camper dealer.', path: '/nc-freedom-popup-dealer' }),
  component: NCFreedomDealer,
});